module.exports = __webpack_public_path__ + "static/store-70710b9f0e65fb54ea25cba7ab656449.png";